import { updateBenchmarkId } from "app/services/patient/patient";
import { useGetBenchmarkInsurancesQuery } from "app/store/insurance/api/insuranceApi";
import { setBenchmarkPatientInsurances } from "app/store/transmission/slice/transmissionSlice";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getCurrentUserRole } from "utils/currentUser.util";
import { showErrorToast, showSuccessToast } from "utils/toast";

const useBenchmarkInsurances = () => {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.transmission);
  const userRole = getCurrentUserRole();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const [originalBenchmarkId, setOriginalBenchmarkId] = useState("");
  const [updatedBenchmarkId, setUpdatedBenchmarkId] = useState("");
  const [showBenchmarkIdEditModal, setShowBenchmarkIdEditModal] =
    useState(false);

  const { data, isLoading: isBenchmarkInsurancesLoading } =
    useGetBenchmarkInsurancesQuery(
      {
        benchmarkId: originalBenchmarkId,
        evokeId: profile?.evoke_id,
      },
      { skip: !originalBenchmarkId || !profile?.evoke_id }
    );

  useEffect(() => {
    dispatch(setBenchmarkPatientInsurances(data?.patientInsurances || {}));
  }, [data]);

  useEffect(() => {
    setOriginalBenchmarkId(profile?.benchmark_id || "");
    setUpdatedBenchmarkId(profile?.benchmark_id || "");
  }, [profile?.benchmark_id]);

  const handleBenchmarkIdUpdate = (benchmarkId) => {
    setUpdatedBenchmarkId(benchmarkId);
  };

  const handleBenchmarkIdSubmit = async () => {
    try {
      setIsSubmitting(true);
      setIsSubmitClicked(true);
      const payload = { benchmarkId: updatedBenchmarkId };
      const result = await updateBenchmarkId(profile?._id, payload);

      if (result?.type === "Success") {
        showSuccessToast(result?.message);
        setOriginalBenchmarkId(updatedBenchmarkId);
        setShowBenchmarkIdEditModal(false);
      }
    } catch (error) {
      showErrorToast("Failed to update Benchmark ID.");
    } finally {
      setIsSubmitting(false);
      setIsSubmitClicked(false);
    }
  };

  return {
    profile,
    userRole,
    isBenchmarkInsurancesLoading,
    benchmarkPatientId: data?.benchmarkId || null,
    showBenchmarkIdEditModal,
    updatedBenchmarkId,
    isSubmitting,
    isSubmitClicked,
    originalBenchmarkId,
    setShowBenchmarkIdEditModal,
    setUpdatedBenchmarkId,
    handleBenchmarkIdUpdate,
    handleBenchmarkIdSubmit,
  };
};
export default useBenchmarkInsurances;
